import { useContext } from 'react'
import { AppDataContext } from '../providers/AppData'

const useHreflangsForLocales = [
  {
    hreflang: 'en-gb',
    locale: 'uk',
    tenant: 'uk'
  },
  {
    hreflang: 'de-at',
    locale: 'de-at',
    tenant: 'de-at'
  },
  {
    hreflang: 'en-ae',
    locale: 'en-ae',
    tenant: 'en-ae'
  },
  {
    hreflang: 'de-de',
    locale: 'de/',
    tenant: 'de'
  },
  {
    hreflang: 'en-au',
    locale: 'au',
    tenant: 'au'
  },
  {
    hreflang: 'en-ie',
    locale: 'ie',
    tenant: 'ie'
  }
]

export const useHomePageHrefLang = () => {
  const { locale } = useContext(AppDataContext)
  const matchedLocale = useHreflangsForLocales.find((item) => item.tenant === locale)
  if (matchedLocale) {
    return useHreflangsForLocales.map((useHreflangsForLocale) => ({
      rel: 'alternate',
      href: `https://www.doctify.com/${useHreflangsForLocale.locale}`,
      hreflang: useHreflangsForLocale.hreflang
    }))
  }
  return undefined
}
